import classes from './ShortSMSPackageCard.module.css';
import CommonCard from '../CommonCard';
import { Col } from 'react-bootstrap';
import clsx from 'clsx';
import { numberFormatter } from '../../../Helpers';
const ShortSMSPackageCard = ({ headerCard, setter, markSelected, data }) => {

  return (
    <Col xs={12}>
      <CommonCard
        onClick={() => {
          if (typeof setter === 'function') setter();
        }}
        // Tag="button"
        className={clsx(classes.cardWrapper, {
          [classes.cardWithHeader]: headerCard,
          [classes.selectedCard]: markSelected
        })}>
        {headerCard && (
          <p
            className={clsx(classes.badge, {
              [classes.selectedBadge]: markSelected
            })}>
            Most Popular
          </p>
        )}
        <ul className={classes.innerWrapper}>
          <li>
            <h3 className={classes.title}>{data?.packageName}</h3>
          </li>
          <li className={classes.moreInfo}>
            <p className={classes.crossOver}>{`Rs. ${numberFormatter(data?.baseAmount)}`}</p>

            <p className={classes.price}>{`Rs. ${numberFormatter(data?.packageAmount)}`}</p>
          </li>
        </ul>
      </CommonCard>
    </Col>
  );
};

export default ShortSMSPackageCard;
